import team from "../assets/AboutPics/team.png";
import team2 from "../assets/AboutPics/team2.jpg";
import logo from "../assets/titlelogo.png";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";
import { FaLinkedin, FaGithub, FaTwitter } from "react-icons/fa";
import SmallCard from "../components/SmallCard";

const About = () => {
  return (
    <>
      {/* Background Images */}
      <div className="-z-10 absolute h-full opacity-4 top-0">
        <img src={logo} alt="bg" className="h-full max-h-70 w-auto object-contain md:translate-y-20" />
      </div>

      <div className="p-10">
        <div className="text-center">
          <h1 className="text-4xl font-bold mt-2">
            About <span className="text-[#19BFB7]">AIAURA</span>
          </h1>
          <p className="mt-2 text-gray-400 max-w-2xl mx-auto">
            Learn more about the company and the team behind it.
          </p>
        </div>

        {/* First Quote */}
        <div className="mt-8 p-4 rounded-lg">
          <p className="text-gray-300 italic text-center">
            "AI That Recognises Talent, Not Just Keywords." <br />
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold">At AIAURA,</h2>
            <p className="mt-4 text-2xl md:text-3xl text-gray-300">
              Our journey began with a spark of innovation and a passion for transforming the way companies build and nurture their teams. We started with a simple yet powerful idea.
            </p>

            <div className="mt-6 bg-blue-900 p-4 rounded-lg border-l-4 border-cyan-400">
              <p className="font-semibold text-2xl text-gray-300">
                Every organization needs more than just a recruitment tool; they need a strategic partner that empowers them to discover hidden potential and foster a thriving workforce.
              </p>
            </div>

            <p className="mt-6 text-gray-300 text-2xl md:text-3xl">
              Founded by a dynamic team of tech enthusiasts and forward-thinking recruiters, AIAURA was built on the principle of innovation and diversity. We envisioned a future where cutting-edge AI meets human insight to revolutionize recruitment and unlock the full potential of every candidate.
            </p>
          </div>
        {/* Background Images */}
<div className="-z-10 absolute h-full opacity-50 left-0 translate-y-[-350px] md:translate-y-[0px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[300px] md:translate-y-[300px] ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
          {/* Image Section */}
          <div className="flex justify-center">
            <img src={team} alt="Team working" className="rounded-xl shadow-lg" />
          </div>
        </div>

        {/* Second Quote */}
        <div className="mt-8 bg-[#11243b] p-4 rounded-lg border-l-4 border-cyan-400">
          <p className="text-gray-300 italic text-center">
            "The Future of Hiring and Workforce Optimization in One Platform"
          </p>
        </div>

 {/* Background Images */}
 <div className="-z-10 absolute h-full opacity-50 left-0 md:translate-y-[0px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[550px] md:translate-y-[100px] ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

        {/* New Section: What We Do */}
<div className="mt-12 p-10 rounded-lg relative text-white">
  <div className="text-center mb-8">
    <p className="text-lg">Our philosophy is simple — hire a team of diverse, passionate people and foster a culture that empowers you to do your best work.</p>
    <button className="mt-4 bg-teal-500 text-white py-2 px-6 rounded-lg transition-transform transform hover:scale-105">
      Contact Us
    </button>
  </div>


  <div className="mt-8 grid md:grid-cols-2 gap-10">
    {/* For Recruitment Teams Card */}
    <div className="bg-[#11243b] p-6 rounded-xl shadow-lg">
      <h3 className="text-2xl font-bold mb-4">For Recruitment Teams</h3>
      <ul className="space-y-4 text-gray-300">
        <li>
          <span className="font-semibold text-white">Boost Efficiency:</span> Automate manual tasks so your team can concentrate on building relationships and strategizing.
        </li>
        <li>
          <span className="font-semibold text-white">Uncover Hidden Gems:</span> Leverage AI to discover talent that traditional methods might overlook.
        </li>
        <li>
          <span className="font-semibold text-white">Data-Driven Decisions:</span> Access real-time analytics that guide your hiring strategy, ensuring you always make informed choices.
        </li>
      </ul>
    </div>

    {/* For Companies Card */}
    <div className="bg-[#11243b] p-6 rounded-xl shadow-lg">
      <h3 className="text-2xl font-bold mb-4">For Companies</h3>
      <ul className="space-y-4 text-gray-300">
        <li>
          <span className="font-semibold text-white">Faster Time-to-Hire:</span> Streamline the entire recruitment cycle to secure top candidates before your competitors do.
        </li>
        <li>
          <span className="font-semibold text-white">Build a Future-Ready Workforce:</span> Identify and address skill gaps within your current team, promoting internal mobility and continuous development.
        </li>
        <li>
          <span className="font-semibold text-white">Reduce Costs:</span> Optimize recruitment spending by reducing manual work and improving overall hiring quality.
        </li>
      </ul>
    </div>
  </div>
</div>


 {/* Background Images */}
 <div className="-z-10 absolute h-full opacity-50 left-0 md:translate-y-[0px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[550px] md:translate-y-[300px] ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className="bg-[#0b1e39] text-white py-12 px-6 rounded-xl flex flex-col md:flex-row items-center justify-center gap-10">
      <div className="max-w-md md:max-w-none">
        <img
          src={team2}
          alt="Team meeting"
          width={500}
          height={500}
          className="rounded-lg shadow-md"
        />
      </div>
      <div className="text-center md:text-left max-w-lg">
  <h2 className="text-3xl md:text-4xl font-bold mb-6">Our AI <span className="text-[#19BFB7]">Philosophy</span></h2>
  <p className="text-gray-400 mb-6">
    At AIAURA, we believe AI should complement human decision-making, not replace it. Our technology is designed to empower recruiters with smarter insights and streamline processes while ensuring that people remain at the heart of every decision. We see AI as a tool to enhance the human experience in recruiting and day-to-day tasks, making it more efficient and data-driven, without losing the personal touch.
  </p>
  <p className="text-gray-400 mb-8">
    We are committed to using AI ethically and responsibly. We focus on fairness, transparency, and equal opportunities, testing our models to ensure they promote a just and unbiased recruitment process.
  </p>
  
  <h2 className="text-3xl md:text-4xl font-bold mb-6">Innovation with <span className="text-[#19BFB7]">Purpose</span></h2>
  <p className="text-gray-400 mb-6">
    At AIAURA, we are continuously innovating to improve both the technology and the people who interact with it. We don't just embrace the latest in AI—we do so with a purpose. Our focus is on creating tools that serve the needs of recruiters, candidates, and businesses alike, ensuring that AI is always used to enhance collaboration, improve outcomes, and make recruitment more human.
  </p>
</div>

    </div>

 {/* Background Images */}
 <div className="-z-10 absolute h-full opacity-50 left-0 md:translate-y-[30px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[500px] ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className="md:hidden -z-10 absolute h-full opacity-50 left-0 translate-y-[1000px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

        {/* Opportunities at AIAURA */}
        <div className="mt-16 text-center mb-30">
  <h2 className="text-4xl font-bold mb-4">Opportunities at AIAURA</h2>
  <p className="text-gray-400 mb-8">
    We're always looking for passionate talent. Stay connected!
  </p>
  <div className="grid md:grid-cols-4 gap-6">
  {[
    'Sales Executive',
    'Future Leaders',
    'Creative Thinkers',
    'Problem Solvers',
    'Tech Enthusiasts',
    'Strategic Minds',
    'Visionaries',
    'Aspiring Experts'
  ].map((role, index) => (
    <a 
      key={index}
      href="https://aiaura.co.uk/candidate/job-apply/9829f110-7729-4d76-8451-a6d580a5c0dd"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-blue-900 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 block cursor-pointer"
    >
      <h3 className="text-xl font-semibold text-white">{role}</h3>
      <p className="text-gray-300 mt-2">Stay tuned for exciting opportunities!</p>
      <div className="flex justify-center mt-4 space-x-4">
        <FaLinkedin className="text-[#19BFB7]" />
      </div>
    </a>
  ))}
</div>
</div>
  </div>
  <SmallCard/>
    </>
  );
};

export default About;
